<template>
  <!-- 投票頁面儀表板區塊 -->
  <div id="VoteDashboard_main">
    <div class="main">
      <div class="title">
        表決票數統計
      </div>
      <div class="voteWrap">
        <div
          v-for="(item, ind) in data"
          :key="ind"
          class="block"
        >
          <div :class="classCallback(item.content)">
            <div :class="['card', showScan ? '' : 'short']">
              <el-button
                v-if="item.id && showScan"
                round
                class="scan"
                @click="openScan(item.id, item.content)"
              >
                掃描
                <i
                  class="icon-m-next"
                  aria-hidden="true"
                />
              </el-button>
              <div class="title">
                {{ item.content }}
              </div>
              <div class="votes">
                {{ item.votesNumber }} 票
              </div>
              <div v-if="showArea">
                <div class="dash" />
                <div class="content">
                  <div class="left">
                    區權比例
                  </div>
                  <div class="right">
                    {{ ratio(item.votesRatio) }} ％
                  </div>
                </div>
                <div class="content">
                  <div class="left">
                    面積總合
                  </div>
                  <div
                    class="right"
                    item.thresholdRatio
                  >
                    {{ item.votesArea }} {{ unit }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ScanVotingPaperDialog
      ref="scanVotingPaperDialog"
      @refresh="refresh"
    />
  </div>
</template>
<script>
import ScanVotingPaperDialog from './ScanVotingPaperDialog.vue'
import tw from '../../utils'

export default {
  components: {
    ScanVotingPaperDialog
  },
  props: {
    data: Array,
    showScan: Boolean, // 顯示掃描button
    showArea: Boolean // 會議出席統計標準僅勾選出席人數時，不顯示坪數、區權比區塊
  },
  data () {
    const { unit } = tw
    return {
      unit
    }
  },
  mounted () {
  },
  methods: {
    openScan (id, optionName) {
      console.log(optionName)
      this.$refs.scanVotingPaperDialog.openDialog(id, optionName)
    },
    refresh () {
      this.$emit('refresh')
    },
    ratio (data) {
      // eslint-disable-next-line eqeqeq
      if (data != '-') { return Math.floor(parseFloat((data * 10000).toPrecision(12))) / 100 }
    },
    classCallback (title) {
      return ['notVoted', 'agreeVote', 'disagreeVote', 'invalidTicket'][['未投票', '同意', '反對', '廢票'].indexOf(title)]
    }
  }
}
</script>
<style lang='sass' scoped>
#VoteDashboard_main
  +mainLayer
  padding-top: 24px
  .main
    border-radius: 0
  .title
    font-size: 23px
    font-weight: 600
    margin-bottom: 24px
  .voteWrap
    display: flex
    .block
      flex: 1
      margin: 0 2px
      .notVoted
        background-color: $bgDarkBg
        .title
          color: $subFontColor
      .agreeVote
        background-color: $whiteHover
        .title
          color: $mainColor
      .disagreeVote
        background-color: rgba(238, 88, 88, 0.2)
        .title
          color: $dangerColor
      .invalidTicket
        background-color: $lightFontColor
        .title
          color: $mainFontColor
      .card
        text-align: left
        padding: 12px 16px
        position: relative
        .title
          font-size: 25px
          line-height: 35px
          margin-bottom: 0
        .el-button.scan
          position: absolute
          top: 12px
          right: 16px
          border-color: $mainColor
          color: $mainColor
          padding: 12px
          i
            padding-right: 0
            font-size: 12px
            position: relative
            top: -1px
        .votes
          font-size: 31px
          line-height: 43px
          font-weight: 600
          margin-bottom: 11px
        .dash
          height: 1px
          background-image: linear-gradient(to right, $borderDark4 0%, $borderDark4 50%, transparent 50%)
          background-size: 15px 1px
          background-repeat: repeat-x
        .content
          display: block
          width: 100%
          color: $mainFontColor
          height: 38px
          line-height: 38px
          margin-top: 8px
          .left
            display: inline-block
            font-size: 19px
          .right
            display: inline-block
            float: right
            font-size: 27px
            font-weight: 600
        &.short
          .votes
            margin-bottom: 4px
</style>
